<template>
  <Main>
    <v-container>
      <v-card class="mx-auto">
        <v-card-text>
          <p class="display-1 text--primary">
            Upload Mapping Sales Assignment
            <v-btn small color="warning" @click="downloadCSV()">Download Template</v-btn>
          </p>
          <div class="text--primary">
            <!-- {{ this.SELECTED_MONTH_PERIOD + " - " + this.SELECTED_YEAR_PERIOD + " - " + this.SELECTED_BRANCH}} -->
            <!-- {{ this.VSELECT_BRANCH }} -->
            <v-row>
              <v-col md="12" sm="12">
                <!-- {{ "CSV : " + this.JSON_FILE_UPLOAD }} -->
                <v-file-input
                  v-model="JSON_FILE_UPLOAD"
                  color="red darken-1"
                  counter
                  label="File input"
                  placeholder="Select your files"
                  prepend-icon="mdi-paperclip"
                  outlined
                  :show-size="1000"
                  @change="onAddFiles($event)"
                >
                  <template v-slot:selection="{ index, text }">
                    <v-chip
                      v-if="index < 2"
                      color="deep-purple accent-4"
                      dark
                      label
                      small
                    >
                      {{ text }}
                    </v-chip>

                    <span
                      v-else-if="index === 2"
                      class="overline grey--text text--darken-3 mx-2"
                    >
                      +{{ files.length - 2 }} File(s)
                    </span>
                  </template>
                </v-file-input>
                <!--
                <FilePond
                  name="test"
                  ref="pond"
                  class-name="my-pond"
                  label-idle="Click or Drop files here..."
                  accepted-file-types="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, text/csv, application/csv"
                  :files="this.JSON_FILE_UPLOAD"
                  :init="handleFilePondInit"
                  v-on:updatefiles="handleFilePondUpdateFile"
                  v-on:removefile="handleFilePondRemoveFile"
                />-->
              </v-col>
            </v-row>
          </div>
        </v-card-text>
      </v-card>

      <v-card class="mx-auto my-3">
        <v-card-text>
          <v-tabs color="white accent-4" fixed-tabs center background-color="indigo" dark>
            <v-tab>Error Mapping</v-tab>
            <v-tab>Clean Data</v-tab>

            <v-tab-item :key="1">
              <v-container fluid>
                <v-row>
                  <v-col class="py-0" md="9" sm="9">
                    <v-text-field
                      color="red darken-1"
                      v-model="searchErrorData"
                      append-icon="mdi-magnify"
                      label="Search Data"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col md="3" sm="3">
                    <v-btn
                      small
                      color="warning"
                      class="float-right"
                      style="width: 100%"
                      @click="downloadCSVError()"
                      >Export Error Mapping</v-btn
                    >
                  </v-col>
                  <v-col md="12" sm="12">
                    <v-data-table
                      :headers="dtHeaders"
                      :items="dtItemsFail"
                      :search="searchErrorData"
                      v-bind:allow-multiple="false"
                      :loading="dtLoading"
                      :item-class="itemRowValidation"
                      loading-text="Fetching Data..."
                    >
                    </v-data-table>
                  </v-col>
                </v-row>
              </v-container>
            </v-tab-item>

            <v-tab-item :key="2">
              <v-container fluid>
                <v-row>
                  <v-col class="py-0" md="7" sm="7">
                    <v-text-field
                      color="red darken-1"
                      v-model="searchCleanData"
                      append-icon="mdi-magnify"
                      label="Search Data"
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col md="5" sm="5">
                    <v-btn
                      small
                      color="warning"
                      class="float-right"
                      :disabled="disableSubmit"
                      @click="confirmModal(submitUpload)"
                      >Submit Uploaded File</v-btn
                    >
                    <v-btn
                      small
                      color="warning"
                      class="float-right mr-3"
                      @click="downloadCSVSuccess()"
                      >Export Clean Data</v-btn
                    >
                  </v-col>
                  <v-col md="12" sm="12">
                    <v-data-table
                      :headers="dtHeaders"
                      :items="dtItemsSuccess"
                      :search="searchCleanData"
                      v-bind:allow-multiple="false"
                      :loading="dtLoading"
                      :item-class="itemRowValidation"
                      loading-text="Fetching Data..."
                    >
                    </v-data-table>
                  </v-col>
                </v-row>
              </v-container>
            </v-tab-item>
          </v-tabs>
        </v-card-text>
      </v-card>
    </v-container>
    <!-- SNACKBAR -->
    <v-snackbar v-model="isShowSnackbar" top>{{ snackbarText }}</v-snackbar>
    <!-- LOADING OVERLAY -->
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <!-- Start Validation Submit -->
    <v-dialog v-model="isOpenModalConfirm" max-width="500px">
      <v-card>
        <v-card-title class="headline"
          ><b style="color: red">[IMPORTANT]</b>&nbsp;&nbsp;Are you Sure to Continue
          ?</v-card-title
        >

        <v-card-text>
          Jika anda menekan tombol submit, sistem akan melakukan input seluruh data yang
          sudah melalui validasi saja. Apakah anda yakin untuk melanjutkan ?
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="red darken-1" text @click="isOpenModalConfirm = false"
            >Cancel</v-btn
          >

          <v-btn color="green darken-1" text @click="methodAction">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End Validation Submit -->
  </Main>
</template>

<style>
.not-valid {
  background-color: rgb(255, 210, 210);
}
td {
  white-space: nowrap;
}
</style>

<script>
import Main from "@/Main.vue";
import XLSX from "xlsx";
import moment from "moment";

// Import the plugin code
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";

// Import Vue FilePond
import vueFilePond, { setOptions } from "vue-filepond";

// Import FilePond styles
import "filepond/dist/filepond.min.css";

// Create component
const FilePond = vueFilePond(FilePondPluginFileValidateType);

setOptions({
  allowMultiple: false,
});

const JSON_FOR_DOWNLOAD = [
  {
    CUSTOMER_ID_REF: "",
    CUSTOMER_NAME: "",
    BISNIS: "",
    TYPE_DESC: "",
    POSITION: "",
    ADD_SALESMAN_POSITION: "NA",
    START_DATE: "MM/DD/YYYY",
  },
];

export default {
  components: {
    Main,
    FilePond,
  },
  data() {
    return {
      searchCleanData: "",
      searchErrorData: "",
      methodAction: "",
      isOpenModalConfirm: false,
      disableSubmit: true,
      FILE_UPLOAD: [],
      JSON_FILE_UPLOAD: [],
      search: "",
      dtLoading: false,
      isShowSnackbar: false,
      snackbarText: "",
      isLoading: false,
      dtLoading: false,
      dtHeaders: [
        {
          text: "CUSTOMER_ID_REF",
          value: "CUSTOMER_ID_REF",
        },
        {
          text: "CUSTOMER_NAME",
          value: "CUSTOMER_NAME",
        },
        {
          text: "BISNIS",
          value: "BISNIS",
        },
        {
          text: "TYPE_DESC",
          value: "TYPE_DESC",
        },
        {
          text: "POSITION",
          value: "POSITION_CODE",
        },
        {
          text: "ADD_SALESMAN_POSITION",
          value: "ADD_SALESMAN_POSITION",
        },
        {
          text: "START_DATE",
          value: "START_DATE",
        },
        {
          text: "CHANNEL",
          value: "CHANNEL",
        },
        {
          text: "PRIORITY",
          value: "PRIORITY",
        },
        {
          text: "VALID",
          value: "IS_VALID",
        },
        {
          text: "REASON",
          value: "REASON",
        },
      ],
      dtItemsSuccess: [],
      dtItemsFail: [],
      previews: [],
      dtValidPeriod: ""
    };
  },
  mounted() {
    this.cekPeriod();
  },
  methods: {
    itemRowValidation: function (item) {
      return item.IS_VALID == "Y" ? "" : "not-valid";
    },
    confirmModal: function (method) {
      this.isOpenModalConfirm = true;
      this.methodAction = method;
    },
    cekPeriod() {
            const userData = JSON.parse(localStorage.getItem("userData"));
              this.isLoading = true;
            let data = {
                typeID: 'NEW MAPPING SALES ASSIGNMENT',
                orgID :  userData.ORG_ID
            };
            this.$http
                .post("/setting/validPeriod", data, {
                  headers: {
                    "api-key": this.$apiKey
                  }
                })
                .then(res => {
                   this.isLoading = false;
                    const {
                        success,
                        message,
                        data
                    } = res.data;
                    this.dtValidPeriod = data.length;
                })
                .catch(err => {
                    this.isLoading = false;
                    this.showSnackbar(err.toString());
                });
    },
    onAddFiles(event) {
      if(this.dtValidPeriod>0){
          try {
            let self = this;
            let file = event;
            const userData = JSON.parse(localStorage.getItem("userData"));
            const reader = new FileReader();
            this.dtItems = [];
            this.disableSubmit = false;

            reader.onload = (e) => {
              var data = new Uint8Array(e.target.result);
              var workbook = XLSX.read(data, {
                type: "array",
                cellDates: true,
              });


              let sheetName = workbook.SheetNames[0];
              /* DO SOMETHING WITH workbook HERE */
              let worksheet = workbook.Sheets[sheetName];
              const XLSXJSON = XLSX.utils.sheet_to_json(worksheet);

              for (let XLSXJSONDATA of XLSXJSON) {
                if (
                  XLSXJSONDATA.CUSTOMER_ID_REF != undefined &&
                  XLSXJSONDATA.CUSTOMER_NAME != undefined &&
                  XLSXJSONDATA.BISNIS != undefined &&
                  XLSXJSONDATA.TYPE_DESC != undefined &&
                  XLSXJSONDATA.POSITION != undefined &&
                  XLSXJSONDATA.ADD_SALESMAN_POSITION != undefined &&
                  XLSXJSONDATA.START_DATE != undefined
                ) {
                  this.isLoading = true;
                  let START_DATE = "";

                  if (file.type == "application/vnd.ms-excel") {
                    START_DATE = moment(new Date(XLSXJSONDATA.START_DATE)).format(
                      "YYYY-MM-DD"
                    );
                    self.dtItems.push({
                      CUSTOMERIDREF: XLSXJSONDATA.CUSTOMER_ID_REF,
                      CUSTOMERNAME: XLSXJSONDATA.CUSTOMER_NAME,
                      BISNIS: XLSXJSONDATA.BISNIS,
                      TYPEDESC: XLSXJSONDATA.TYPE_DESC,
                      POSITIONCODE: XLSXJSONDATA.POSITION,
                      ADDSALESMANPOSITION:
                        XLSXJSONDATA.ADD_SALESMAN_POSITION != undefined
                          ? XLSXJSONDATA.ADD_SALESMAN_POSITION
                          : "NA",
                      STARTDATE: START_DATE,
                      IS_VALID: "Y",
                      ASSIGNMENTUSERIDUPDATE: userData.USER_ID,
                    });
                  } else if (
                    file.type ==
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  ) {
                    // START_DATE = moment(new Date(XLSXJSONDATA.START_DATE))
                    //   .add(1, "days")
                    //   .format("YYYY-MM-DD");
                    self.isLoading = false;
                    self.isOpenModalConfirm = false;
                    self.showSnackbar("Gunakan template XLS");
                  }
                }
              }
              if (self.dtItems.length > 0) {
                self.isOpenModalConfirm = false;
                self.isLoading = true;
                self.$http
                  .post("/mapping-sales-assignment/validation", {
                    excelData: self.dtItems,
                    orgID: userData.ORG_ID,
                  }, {
                    headers: {
                      "api-key": this.$apiKey
                    }
                  })
                  .then((res) => {
                    const { success, data, message } = res.data;
                    let valid = true;
                    let reason = "";
                    if (success) {
                      self.isLoading = false;

                      if (data.success) {
                        data.success.forEach((obj, index) => {
                          data.success[index].START_DATE = moment(
                            data.success[index].START_DATE
                          ).format("MM/DD/YYYY");

                          data.success[index].END_DATE = moment(
                            new Date(data.success[index].END_DATE)
                          ).format("MM/DD/YYYY");
                          data.success[index].ASSIGNMENT_LAST_UPDATE = moment(
                            new Date(data.success[index].ASSIGNMENT_LAST_UPDATE)
                          ).format("MM/DD/YYYY");
                        });
                      }

                      if (data.failed[0] != undefined) {
                        if (
                          data.failed[0].REASON == "Start Date tidak sesuai." ||
                          data.failed[0].REASON == "Branch/Position tidak sesuai."
                        ) {
                          valid = false;
                          self.JSON_FILE_UPLOAD = [];
                          self.showSnackbar(data.failed[0].REASON);
                        } else {
                          if (data.failed) {
                            data.failed.forEach((obj, index) => {
                              data.failed[index].START_DATE = moment(
                                new Date(data.failed[index].START_DATE)
                              ).format("MM/DD/YYYY");
                              data.failed[index].END_DATE = moment(
                                new Date(data.failed[index].END_DATE)
                              ).format("MM/DD/YYYY");
                              data.failed[index].ASSIGNMENT_LAST_UPDATE = moment(
                                new Date(data.failed[index].ASSIGNMENT_LAST_UPDATE)
                              ).format("MM/DD/YYYY");
                            });
                          }
                          self.dtItemsSuccess = data.success;
                          self.dtItemsFail = data.failed;                          
                          self.disableSubmit = true;
                          self.showSnackbar(message);
                        }
                      } else {
                        self.isLoading = false;
                        self.dtItemsSuccess = data.success;
                        self.dtItemsFail = data.failed;
                        self.showSnackbar(message);
                      }
                    } else {
                      self.isLoading = false;
                      self.showSnackbar(message);
                    }
                  })
                  .catch((err) => {
                    self.isLoading = false;
                    console.log(err.toString());
                    self.showSnackbar(err.toString());
                  });
              } else {
                self.isLoading = false;
                self.isOpenModalConfirm = false;
                // Edited By Dedian 29 Juli 2021 //
                self.showSnackbar("Gunakan template XLS");
              }
            };

            if (file) {
              reader.readAsArrayBuffer(file);
            }
          } catch (e) {
            this.isLoading = false;
            this.isOpenModalConfirm = false;
            this.showSnackbar(e);
          }
       }else{
          this.showSnackbar(
                  "Periode sudah ditutup."
                );
      } 
    },
    submitUpload() {
      console.log('this.$apiKey ', this.$apiKey)
      let self = this;
      if (self.dtItems.length > 0) {
        self.isOpenModalConfirm = false;
        self.isLoading = true;
        self.$http
          .post("/mapping-sales-assignment/upload", {
                    excelData: '',
                    orgID: '',
                  }, {
                    headers: {
                      "api-key": this.$apiKey
                    }
                  })
          .then((res) => {
            const { success, message } = res.data;
            if (success) {
              self.isLoading = false;
              self.showSnackbar(message);
              self.$router.push({
                path: `/mapping-sales-assignment/overview`,
              });
            } else {
              self.isLoading = false;
              self.showSnackbar(message);
            }
          })
          .catch((err) => {
            self.isLoading = false;
            self.showSnackbar(err.toString());
          });
      } else {
        self.isLoading = false;
        self.isOpenModalConfirm = false;
        self.showSnackbar("Please Upload CSV File First !");
      }
    },
    downloadCSV() {
      const workBook = XLSX.utils.book_new(); // create a new blank book
      const workSheet = XLSX.utils.json_to_sheet(JSON_FOR_DOWNLOAD);
      XLSX.utils.book_append_sheet(workBook, workSheet, "Sheet1"); // add the worksheet to the book
      XLSX.writeFile(workBook, "Template Mapping Assignment.xls"); // initiate a file download in browser
    },
    downloadCSVError() {
      const workBook = XLSX.utils.book_new(); // create a new blank book
      const workSheet = XLSX.utils.json_to_sheet(this.dtItemsFail);
      XLSX.utils.book_append_sheet(workBook, workSheet, "Sheet1"); // add the worksheet to the book
      XLSX.writeFile(workBook, "Error Mapping Assignment.xls"); // initiate a file download in browser
    },
    downloadCSVSuccess() {
      const workBook = XLSX.utils.book_new(); // create a new blank book
      const workSheet = XLSX.utils.json_to_sheet(this.dtItemsSuccess);
      XLSX.utils.book_append_sheet(workBook, workSheet, "Sheet1"); // add the worksheet to the book
      XLSX.writeFile(workBook, "Valid Data Mapping Assignment.xls"); // initiate a file download in browser
    },
    showSnackbar(text) {
      this.snackbarText = text;
      this.isShowSnackbar = true;
    },
  },
};
</script>
